import { render, staticRenderFns } from "./pendingChanges.vue?vue&type=template&id=fe9cbc90&scoped=true&"
import script from "./pendingChanges.vue?vue&type=script&lang=js&"
export * from "./pendingChanges.vue?vue&type=script&lang=js&"
import style0 from "./pendingChanges.vue?vue&type=style&index=0&id=fe9cbc90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe9cbc90",
  null
  
)

component.options.__file = "pendingChanges.vue"
export default component.exports